// Spinner — lucide Loader2 + Tailwind animate-spin.
//
// Sizes map to: sm = 16px, md = 24px, lg = 32px.

import { Loader2 } from 'lucide-react';
import type { ReactElement, SVGAttributes } from 'react';

import { cn } from './utils/cn.js';

export interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg';
  /** Accessible label. Defaults to "Загрузка…". Pass empty string to hide. */
  label?: string;
}

const SIZE_CLASS: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function Spinner({
  className,
  size = 'md',
  label = 'Загрузка…',
  ...props
}: SpinnerProps): ReactElement {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center">
      <Loader2
        className={cn('animate-spin text-muted-foreground', SIZE_CLASS[size], className)}
        aria-hidden="true"
        {...props}
      />
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
